import React, { useEffect } from 'react'
import anime from 'animejs/lib/anime.es.js';

const BgAnim = () => {
    useEffect(() => {
        const animateSpans = () => {
            anime({
                targets: '#shap',
                translateX: () => anime.random(-450, 450),
                translateY: () => anime.random(-250, 250),
                easing: 'cubicBezier(.5, .05, .1, .3)',
                duration: 2000,
                delay: anime.stagger(10),
                complete: animateSpans
            });
        };

        animateSpans();
    }, []);
    return (
        <div className='shaps w-full absolute top-0'>
            <div className='h-[60vh] sm:h-[80vh] md:w-4/5 mx-auto md:h-screen flex items-center justify-center relative overflow-hidden blur-2xl'>
                <span className='shap1 absolute bg-[#FF8B0A] dark:bg-white h-32 w-32 rounded-full'></span>
                <span className='shap2 absolute bg-[#FF8B0A] dark:bg-white h-28 w-28 rounded-full'></span>
                <span className='shap3 absolute five-star'></span>
                <span className='shap4 absolute five-star'></span>
                <span className='shap5 absolute five-star'></span>
                <span className='shap6 absolute polygon'></span>
                <span className='shap7 absolute polygon'></span>
            </div>
        </div>
    )
}

export default BgAnim

// import React, { useEffect, useState } from 'react';
// import anime from 'animejs/lib/anime.es.js';

// const BgAnim = () => {
//     const [visible, setVisible] = useState(false);

//     useEffect(() => {
//         // Delay the visibility and animation by 5 seconds
//         const timer = setTimeout(() => {
//             setVisible(true);
//             const animateSpans = () => {
//                 anime({
//                     targets: '.shap',
//                     translateX: () => anime.random(-450, 450),
//                     translateY: () => anime.random(-250, 250),
//                     easing: 'cubicBezier(.5, .05, .1, .3)',
//                     duration: 2000,
//                     delay: anime.stagger(10),
//                     complete: animateSpans
//                 });
//             };
//             animateSpans();
//         }, 2000); // 2-second delay

//         return () => clearTimeout(timer); // Cleanup the timer on unmount
//     }, []);

//     return (
//         <div className={`shaps w-full absolute top-0 ${!visible && 'hidden'}`}>
//             <div className='hidden h-[50vh] md:h-[100vh] sm:flex items-center justify-center relative overflow-hidden backdrop-blur-2xl blur-2xl'>
//                 <span className='shap absolute bg-[#FF8B0A] dark:bg-white h-32 w-32 rounded-full'></span>
//                 <span className='shap absolute bg-[#FF8B0A] dark:bg-white h-32 w-32 rounded-full'></span>
//                 <span className='shap absolute five-star'></span>
//                 <span className='shap absolute five-star'></span>
//                 <span className='shap absolute five-star'></span>
//                 <span className='shap absolute polygon'></span>
//                 <span className='shap absolute polygon'></span>
//             </div>
//         </div>
//     );
// }

// export default BgAnim;
